export default "__VITE_ASSET__BDbH1CQC__"